import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, staggerContainer, staggerItem } from './ui/FadeIn';
import { Brain, MoonStar, HeartHandshake, Apple, Home } from 'lucide-react';
const benefits = [{
  icon: <Brain size={24} data-id="element-1" />,
  title: 'Silencio Mental',
  description: 'Técnicas de 5 minutos para apagar el ruido del TDAH y la ansiedad.'
}, {
  icon: <MoonStar size={24} data-id="element-2" />,
  title: 'Descanso Real',
  description: 'Cómo preparar tu cerebro para dormir sin que el corazón te palpite con fuerza.'
}, {
  icon: <HeartHandshake size={24} data-id="element-3" />,
  title: 'Paciencia Recuperada',
  description: 'El secreto para dejar de reaccionar con gritos y empezar a responder con calma.'
}, {
  icon: <Apple size={24} data-id="element-4" />,
  title: 'Protocolo Biológico',
  description: 'Qué suplementos y nutrientes (como el Magnesio) necesita tu cerebro sobrecargado para dejar de disparar alertas de pánico.'
}, {
  icon: <Home size={24} data-id="element-5" />,
  title: 'Orden TDAH',
  description: 'Un sistema minimalista para que tu casa funcione aunque no tengas ayuda de nadie.'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-cream-alt" data-id="element-6">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-7">
        <FadeIn className="text-center mb-16" data-id="element-8">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-9">
            Lo Que Vas a Lograr
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full opacity-50" data-id="element-10" />
        </FadeIn>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-11">
          {benefits.map((benefit, index) => <motion.div key={index} variants={staggerItem} className={`bg-cream p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-warm-deep/50 ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-12">
              <div className="w-12 h-12 rounded-full bg-sage/10 text-sage flex items-center justify-center mb-6" data-id="element-13">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-gold-dark mb-3" data-id="element-14">
                {benefit.title}
              </h3>
              <p className="text-brown-light leading-relaxed" data-id="element-15">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}